export enum AlertStatus {
  active = 'active',
  cleared = 'cleared'
}
